import React, {useState} from 'react';
import {Checkbox, Textarea, TextInput} from "@mantine/core";
import {useElementOnScreen} from "../../shared/hook/useElementOnScreen";
import {useNavigate} from "react-router-dom";
import {notifications} from "@mantine/notifications";
import {useFormContext} from "../../app/providers";
import { PatternFormat } from 'react-number-format';
import S from './RequestForm.module.scss';

export const RequestForm = () => {
  const [formRef, isVisible] = useElementOnScreen<HTMLElement>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const form = useFormContext();

  const sendRequest = async (values: typeof form.values) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('company', values.company || '');
    formData.append('phone', values.phone.replace(/\D/g, ''));
    formData.append('email', values.email);
    formData.append('message', values.message || '');

    const response = await fetch('/api/v1/request', {
      method: 'POST',
      body: formData,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Ошибка ${response.status}: ${errorText || response.statusText}`);
    }

    return {success: true};
  };

  const handleSubmit = form.onSubmit(async (values) => {
    setIsLoading(true);

    try {
      await sendRequest(values);
      notifications.show({
        color: 'green',
        autoClose: 5000,
        title: 'Заявка успешно отправлена!',
        message: '',
      })
      form.reset();

    } catch (error) {
      notifications.show({
        color: 'red',
        autoClose: 5000,
        title: 'Произошла ошибка при отправке. Пожалуйста, попробуйте позже.',
        message: '',
      })
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <section className={S.container} id='requestForm' ref={formRef}>
      <div className={`${S.requestForm} ${isVisible ? S.visible : ''}`}>
        <div className={S.leftBlock}>
          <h2 className={S.title}>Оставить Заявку</h2>
        </div>

        <div className={S.rightBlock}>
          <form className={`${S.form} ${isVisible ? S.visible : ''}`} onSubmit={handleSubmit}>
            <div className={S.formRow}>
              <div className={S.formGroup}>
                <TextInput
                  variant="filled"
                  placeholder="имя, фамилия*"
                  key={form.key('name')}
                  {...form.getInputProps('name')}
                />
              </div>

              <div className={S.formGroup}>
                <TextInput
                  variant="filled"
                  placeholder="название организации"
                  key={form.key('company')}
                  {...form.getInputProps('company')}
                />
              </div>
            </div>

            <div className={S.formRow}>
              <div className={S.formGroup}>
                <PatternFormat
                  format="+7 ### ### ## ##"
                  mask="_"
                  customInput={TextInput}
                  variant="filled"
                  placeholder="телефон*"
                  value={form.values.phone}
                  {...form.getInputProps('phone')}
                />
              </div>

              <div className={S.formGroup}>
                <TextInput
                  variant="filled"
                  placeholder="email*"
                  key={form.key('email')}
                  {...form.getInputProps('email')}
                />
              </div>
            </div>

            <div className={S.formGroup}>
              <Textarea
                placeholder="ваше сообщение"
                autosize
                minRows={2}
                maxRows={4}
                key={form.key('message')}
                {...form.getInputProps('message')}
              />
            </div>

            <div className={S.checkboxGroup}>

              <Checkbox
                className={S.checkboxLabel}
                label={
                  <span className={S.checkboxText}>
                    согласен на обработку <u onClick={(e) => {
                    e.stopPropagation();
                    navigate('/agreement');
                  }}>персональных данных</u>
                  </span>
                }
                color="orange"
                key={form.key('check')}
                {...form.getInputProps('check', {type: 'checkbox'})}
              />
            </div>

            <button type="submit" className={S.submitButton}>
              {isLoading ? 'отправка...' : 'отправить'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};